module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "ppp-cactus007htmlprologue"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/pppcactus005#ppp-cactus005htmltoc"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("I didn’t know if I would ever tell this story. It was 1999, a strange time, not long after I had returned to Phoenix. Everybody seemed flush, pundits predicted the Dow would reach 36,000, and even deputies day-traded stocks. Health-conscious yuppies smoked fifty-dollar Churchills in plush cigar bars, and the Internet was everywhere. Peralta kept giving me work at the Sheriff’s Office, and I was spending my nights with a young woman named Lindsey. Later, what happened next would seem like a dream, like another man’s life. I would never have gotten into such troubles. But I did. This is how it happened.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27edbb86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ppp-cactus007.vue
// module id = 75
// module chunks = 0